import React from 'react';
import { useSearchParams } from 'react-router-dom';

import SavedFilters from '../../../components/SavedFilters';
import MemberTabs from './MemberTabs';

// One toolbar row shared by every Members list: the list-version tabs + saved
// filters on the left, and the list's own limit/sort control (passed as
// children) on the right — so the tabs sit in line with the limit control.
const MembersToolbar: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [searchParams] = useSearchParams();
    const listVersion = searchParams.get('list_version') || 'active';

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '2.8rem',
                minHeight: '4rem',
                marginBottom: '3.6rem'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '2.8rem' }}>
                <MemberTabs />
                <SavedFilters
                    storageKey={`ep:saved-filters:members:${listVersion}`}
                    ignoreParams={['list_version']}
                    showLeadingDivider
                />
            </div>
            {children}
        </div>
    );
};

export default MembersToolbar;
